import { renderJSON } from '../../utils';
import { getNSReport } from '../../api-calls';


/**
 * Get data from NS Shipments and display table.
 *
 * @param {object} row - Record corresponding to the clicked row.
 */
export function getShipmentReportNS(row) {
  const closeReport = $('#closeShipmentReport');
  const header = $('#headerNS');
  const spinner = $('#nsReportSpinner');
  const tableNS = $('#tableNS');

  // TODO: Use async-await
  getNSReport(row.id).then((data) => {
      header.addClass('d-flex');
      spinner.attr('hidden', true);
      closeReport.prop('disabled', false);

      // Display UPRR API data
      tableNS.html('');
      tableNS.append(renderJSON(data[0]));
      tableNS.prop('hidden', false);
  }).catch(error => {
    spinner.attr('hidden', true);
    closeReport.prop('disabled', false);
    header.addClass('d-flex');

    if (error.status === 404) {
      $('#infoNSText').text('Not found');
    } else {
      $('#infoNSText').text('Error in API request');
    }
  });
}
